<div class="poll-create-wrapper">
  <div class="modal-header text-color-primary">
    <h4>{{'WEBCLIENT.CHATROOM.POLL.CREATE_TITLE' | translate}}</h4>
  </div>
  <div class="modal-body">

    <div class="form-group">
      <label>{{'WEBCLIENT.CHATROOM.POLL.QUESTION_LABEL' | translate}}</label>
      <input type="text"
        class="form-control"
        [maxlength]="POLL_TITLE_MAX_LENGTH"
        [placeholder]="'WEBCLIENT.CHATROOM.POLL.TITLE_PLACEHOLDER' | translate"
        [(ngModel)]="title">
    </div>

    <div class="form-group">
      <label>{{'WEBCLIENT.CHATROOM.POLL.OPTIONS_LABEL' | translate}}</label>
      <!-- trackBy index: options are plain strings, so the default identity trackBy would destroy
           and recreate the input on every keystroke, losing focus after one character -->
      <div class="option-row" *ngFor="let option of options; let i = index; trackBy: trackByIndex">
        <input type="text"
          class="form-control"
          [maxlength]="POLL_OPTION_MAX_LENGTH"
          [placeholder]="'WEBCLIENT.CHATROOM.POLL.OPTION_PLACEHOLDER' | translate: {NUM: i + 1}"
          [(ngModel)]="options[i]">
        <div class="reorder-option-icons">
          <i class="fa fa-chevron-up"
            [ngClass]="{'clickable': i > 0, 'disabled': i === 0}"
            (click)="moveOption(i, -1)"></i>
          <i class="fa fa-chevron-down"
            [ngClass]="{'clickable': i < options.length - 1, 'disabled': i === options.length - 1}"
            (click)="moveOption(i, 1)"></i>
        </div>

        <i class="fa fa-times-circle remove-option-icon clickable"
          *ngIf="options.length > POLL_OPTION_MIN_COUNT"
          (click)="removeOption(i)"></i>
      </div>
      <div class="add-option clickable text-color-primary" *ngIf="options.length < POLL_OPTION_MAX_COUNT" (click)="addOption()">
        <i class="fa fa-plus-circle"></i> {{'WEBCLIENT.CHATROOM.POLL.ADD_OPTION' | translate}}
      </div>
    </div>

    <div class="form-group">
      <label>
        <input type="checkbox" [(ngModel)]="allowMultipleChoice">
        {{'WEBCLIENT.CHATROOM.POLL.ALLOW_MULTIPLE_CHOICE' | translate}}
      </label>
    </div>

    <div class="form-group">
      <label>{{'WEBCLIENT.CHATROOM.POLL.DISPLAY_RESULT_LABEL' | translate}}</label>
      <div class="display-result-options">
        <label class="radio-label" *ngFor="let option of shouldDisplayResultOptions">
          <input type="radio" name="should-display-result" [value]="option.value" [(ngModel)]="shouldDisplayResult">
          {{option.labelKey | translate}}
        </label>
      </div>
    </div>

    <div class="form-group">
      <label>
        <input type="checkbox" [(ngModel)]="isSetVoteEnd" (change)="onToggleVoteEnd()">
        {{'WEBCLIENT.CHATROOM.POLL.END_TIME_TOGGLE' | translate}}
      </label>
      <input type="datetime-local" class="form-control" [(ngModel)]="voteEndInput" *ngIf="isSetVoteEnd">
      <div class="tip" *ngIf="showAfterVoteEndHint">
        {{'WEBCLIENT.CHATROOM.POLL.END_TIME_HINT_NO_END_TIME' | translate}}
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button class="btn btn-default" (click)="cancel()">
      {{'GENERAL.CANCEL' | translate}}
    </button>
    <button class="btn tn-button-primary" (click)="confirm()">
      {{'WEBCLIENT.CHATROOM.POLL.CREATE_BUTTON' | translate}}
    </button>
  </div>
</div>
